import { createBrowserRouter } from "react-router-dom";
import Main from "../../Layout/Main";
import Home from "../../Pages/Home/Home/Home";

import PrivateRoute from "../PrivateRoute/PrivateRoute";
import DashboardLayout from "../../Layout/DashboardLayout";

import SignUpPage from "../../Pages/SignUp/SignUpPage";
import LoginPage from "../../Pages/Login/LoginPage";
import PrivateRouteTwo from "../PrivateRouteTwo/PrivateRouteTwo";
import DashboardTwo from "../../Pages/DashboardTwo/DashboardTwo";

import TutorPayment from "../../Pages/TutorPayment/TutorPayment";
import TutorSettings from "../../Pages/TutorSettings/TutorSettings";
import EducationalProfile from "../../Pages/TutorProfile/EducationalProfile";
import PersonalProfile from "../../Pages/TutorProfile/PersonalProfile";
import ReqTutor from "../../Pages/Students/ReqTutor/ReqTutor";
import TermConditions from "../../Pages/Students/TermConditions/TermConditions";

import PendingConfirmation from "../../Pages/AdminDashboard/ProcessingLeads/PendingConfirmation/PendingConfirmation";
import PendingVerification from "../../Pages/AdminDashboard/ProcessingLeads/PendingVerification/PendingVerification";
import FollowUpTutor from "../../Pages/AdminDashboard/ProcessingLeads/FollowUpTutor/FollowUpTutor";
import FollowUpGuardian from "../../Pages/AdminDashboard/ProcessingLeads/FollowUpGuardian/FollowUpGuardian";
import UserDatabase from "../../Pages/AdminDashboard/UserDatabase/UserDatabase";
import Refunds from "../../Pages/AdminDashboard/Refunds/Refunds";
import Performance from "../../Pages/AdminDashboard/Performance/Performance";
import PrivacyPolicy from "../../Pages/SignUp/PrivacyPolicy";
import AdminLeadsDetails from "../../Pages/AdminDashboard/AdminLeads/AdminLeadsDetails";
import AdminAddLeads from "../../Pages/AdminDashboard/AdminLeads/AdminAddLeads";
import PendingConfirmationDetails from "../../Pages/AdminDashboard/ProcessingLeads/PendingConfirmation/PendingConfirmationDetails";
import PendingVerificationDetails from "../../Pages/AdminDashboard/ProcessingLeads/PendingVerification/PendingVerificationDetails";
import FollowUpTutorDetails from "../../Pages/AdminDashboard/ProcessingLeads/FollowUpTutor/FollowUpTutorDetails";
import FollowUpGuardianDetails from "../../Pages/AdminDashboard/ProcessingLeads/FollowUpGuardian/FollowUpGuardianDetails";
import AllInvoiceDetails from "../../Pages/AdminDashboard/AllInvoice/AllInvoiceDetails";
import InvoiceJobDetails from "../../Pages/AdminDashboard/AllInvoice/InvoiceJobDetails";
import AllJobAdmin from "../../Pages/AdminDashboard/AllJobs/AllJobAdmin";
import TutorJobDetails from "../../Pages/TutorPayment/TutorJobDetails";
import SuperInvoice from "../../Pages/SuperAdmin/SuperAdminInvoice/SuperInvoice";
import SuperInvoiceDetails from "../../Pages/SuperAdmin/SuperAdminInvoice/SuperInvoiceDetails";
import VerifyPassStudents from "../../Pages/Login/VerifyPassStudents";
import VerifyPassTeacher from "../../Pages/Login/VerifyPassTeacher";
import StudentSettingsTwo from "../../Pages/Students/StudentSettings/StudentSettingsTwo";
import PendingDetails from "../../Pages/Students/StudentsDashboard/PendingDetails";

import TutorDashboardDetails from "../../Pages/TutorDashboard/TutorDashboardDetails";
import VerifyLink from "../../Pages/SignUp/VerifyLink";
import PreferProfileTwo from "../../Pages/TutorProfile/PreferProfileTwo";
import JobBoardDetails from "../../Pages/AllTutors/JobBoardDetails";
import TermsCondtionsTutor from "../../Pages/TutorPayment/TermsCondtionsTutor";
import TermsConditonsMain from "../../Pages/Home/TermsConditonsMain";
import TutorDatabaseDetails from "../../Pages/AdminDashboard/UserDatabase/TutorDatabaseDetails";
import GuardianDatabaseDetails from "../../Pages/AdminDashboard/UserDatabase/GuardianDatabaseDetails";
import RequestRefoundDetails from "../../Pages/TutorPayment/RequestRefoundDetails";
import RequestRefundsDetails from "../../Pages/AdminDashboard/Refunds/RequestRefundsDetails";
import SuperAdminDashboard from "../../Pages/SuperAdminAllFolder/SuperAdminDashboard/SuperAdminDashboard";
import SuperAdminLeads from "../../Pages/SuperAdminAllFolder/SuperAdminLeads/SuperAdminLeads";
import SuperAdminPendingConfirmation from "../../Pages/SuperAdminAllFolder/SuperAdminProcessingLeads/SuperAdminPendingConfirmation/SuperAdminPendingConfirmation";
import SuperAdminPendingVerification from "../../Pages/SuperAdminAllFolder/SuperAdminProcessingLeads/SuperAdminPendingVerification/SuperAdminPendingVerification";
import SuperAdminFollowUpTutor from "../../Pages/SuperAdminAllFolder/SuperAdminProcessingLeads/SuperAdminFollowUpTutor/SuperAdminFollowUpTutor";
import SuperAdminFollowUpGuardian from "../../Pages/SuperAdminAllFolder/SuperAdminProcessingLeads/SuperAdminFollowUpGuardian/SuperAdminFollowUpGuardian";
import SuperAdminClassBooked from "../../Pages/SuperAdminAllFolder/SuperAdminProcessingLeads/SuperAdminClassBooked/SuperAdminClassBooked";
import SuperAdminAddLeads from "../../Pages/SuperAdminAllFolder/SuperAdminLeads/SuperAdminAddLeads";
import SuperRefunds from "../../Pages/SuperAdminAllFolder/SuperRefunds/SuperRefunds";
import SARefundRequestDetails from "../../Pages/SuperAdminAllFolder/SuperRefunds/SARefundRequestDetails";
import SARefundedDoneDetails from "../../Pages/SuperAdminAllFolder/SuperRefunds/SARefundedDoneDetails";
import SARefundRequestDeniedDetails from "../../Pages/SuperAdminAllFolder/SuperRefunds/SARefundRequestDeniedDetails";
import SuperAdminAllApplicationsTwo from "../../Pages/SuperAdminAllFolder/SuperAdminProcessingLeads/SuperAdminAllApplications/SuperAdminAllApplicationsTwo";
import SuperAdminShortlistedTwo from "../../Pages/SuperAdminAllFolder/SuperAdminProcessingLeads/SuperAdminShortlisted/SuperAdminShortlistedTwo";

import Error from "../../Pages/TutorPayment/BkashComponent/Error";
import Success from "../../Pages/TutorPayment/BkashComponent/Success";
import TutorSubPaymentDetailsBkash from "../../Pages/TutorPayment/TutorSubPaymentDetailsBkash";
import SuperAdminPerformance from "../../Pages/SuperAdminAllFolder/SuperAdminPerformance/SuperAdminPerformance";
import JobBoardGreen from "../../Pages/AllTutors/JobBoardOuter/JobBoardGreen";
import TutorProfileGreen from "../../Pages/TutorProfile/GreenTutorProfile.js/TutorProfileGreen";
import JobBoardInnerGreen from "../../Pages/AllTutors/JobBoardInner/JobBoardInnerGreen";
import JobBoardInnerDetails from "../../Pages/AllTutors/JobBoardInner/JobBoardInnerDetails";
import RequestRefound from "../../Pages/TutorPayment/RequestRefound";
import LeadsGreen from "../../Pages/AdminDashboard/AdminLeads/LeadsGreen/LeadsGreen";
import AllApplicationsGreen from "../../Pages/AdminDashboard/ProcessingLeads/AllApplications/AllApplicationsGreen";
import AllApplicationGreenDetails from "../../Pages/AdminDashboard/ProcessingLeads/AllApplications/AllApplicationDeitalsGreen/AllApplicationGreenDetails";
import AdminShortListedGreen from "../../Pages/AdminDashboard/ProcessingLeads/AdminShortListed/AdminShortListedGreen/AdminShortListedGreen";
import AdminShortListedGreenDetails from "../../Pages/AdminDashboard/ProcessingLeads/AdminShortListed/AdminShortListedGreen/AdminShortListedGreenDetails";
import ClassBookedGreen from "../../Pages/AdminDashboard/ProcessingLeads/ClassBooked/ClassBookedGreen/ClassBookedGreen";
import ClassBookedGreenDetails from "../../Pages/AdminDashboard/ProcessingLeads/ClassBooked/ClassBookedGreen/ClassBookedGreenDetails";
import TutorPaymentGreenAll from "../../Pages/TutorPayment/TutorPaymentGreen/TutorPaymentGreenAll";
import MainInvoicePage from "../../Pages/AdminDashboard/AllInvoice/AdminInvoiceGreen/MainInvoicePage";
import StudentDashGreen from "../../Pages/Students/StudentDashGreen/StudentDashGreen";
import StudentJobCardDetails from "../../Pages/Students/StudentDashGreen/StudentJobCardDetails";
import TutorDashBoardGreen from "../../Pages/TutorDashboard/TutorDashGreen.js/TutorDashBoardGreen";
import AdminTutors from "../../Pages/AllTutors/AdminTutors";
import SMSGreen from "../../Pages/AdminDashboard/SMS/SMSGreen";
import AdminDashGreenMain from "../../Pages/AdminDashboard/AdminDash/AdminDashGreen/AdminDashGreenMain";
import SignUpTutorMobile from "../../Pages/SignUp/SignUpMobile/SignUpTutorMobile";
import SignUpStudentMobile from "../../Pages/SignUp/SignUpMobile/SignUpStudentMobile";
import SignUpMobile from "../../Pages/SignUp/SignUpMobile/SignUpMobile";
import LoginMobile from "../../Pages/Login/LoginMobile/LoginMobile";
import LoginTutorMobile from "../../Pages/Login/LoginMobile/LoginTutorMobile";
import LoginStudentMobile from "../../Pages/Login/LoginMobile/LoginStudentMobile";
import JobBoardMobile from "../../Pages/AllTutors/JobBoardMobile/JobBoardMobile";
import DashboardTutorMobile from "../../Pages/DashboardTutorMobile/DashboardTutorMobile";
import PrivateRouteTutorMobile from "../PrivateRouteTutorMobile/PrivateRouteTutorMobile";
import TutorProfileMobile from "../../Pages/DashboardTutorMobile/TutorProfileMobile/TutorProfileMobile";
import TutorJobBoardInnerMobile from "../../Pages/DashboardTutorMobile/TutorJobBoardInnerMobile";
import TutorSettingMobile from "../../Pages/DashboardTutorMobile/TutorSettingMobile";
import TutorPaymentMobile from "../../Pages/DashboardTutorMobile/TutorPaymentMobile";
import DashTutorMobile from "../../Pages/DashboardTutorMobile/DashTutorMobile/DashTutorMobile";



const router = createBrowserRouter([
    {
        path: '/',
        element: <Main></Main>,
        children: [
            {
                path: '/',
                element: <Home></Home>
            },
            {
                path: '/login',
                element: <LoginPage></LoginPage>
            },
            {
                path: '/loginMobile',
                element: <LoginMobile></LoginMobile>
            },
            {
                path: '/loginTutorMobile',
                element: <LoginTutorMobile></LoginTutorMobile>
            },
            {
                path: '/loginStudentMobile',
                element: <LoginStudentMobile></LoginStudentMobile>
            },
            {
                path: '/signup',
                element: <SignUpPage></SignUpPage>
            },
            {
                path: '/signupMobile',
                element: <SignUpMobile></SignUpMobile>
            },
            {
                path: '/signupTutorMobile',
                element: <SignUpTutorMobile></SignUpTutorMobile>
            },
            {
                path: '/signupStudentMobile',
                element: <SignUpStudentMobile></SignUpStudentMobile>
            },
            {
                path: '/privacyPolicy',
                element: <PrivacyPolicy></PrivacyPolicy>
            },
            {
                path: '/verifyStudents',
                element: <VerifyPassStudents></VerifyPassStudents>
            },
            {
                path: '/verifyTeacher',
                element: <VerifyPassTeacher></VerifyPassTeacher>
            },
            {
                path: '/verifyLink',
                element: <VerifyLink></VerifyLink>
            },
            {
                path: '/jobBoard',
                element: <JobBoardGreen></JobBoardGreen>
            },
            {
                path: '/jobMobile',
                element: <JobBoardMobile></JobBoardMobile>
            },
            {
                path: '/termConditions',
                element: <TermsConditonsMain></TermsConditonsMain>
            },
            {
                path: '/jobBoardDetails/:id',
                loader: ({ params }) => fetch(`https://tutor-tree-server-1.vercel.app/allTutors/${params.id}`),
                element: <JobBoardDetails></JobBoardDetails>
            },

        ]
    },
    // students
    {
        path: '/dashboard',
        element: <PrivateRoute><DashboardLayout></DashboardLayout></PrivateRoute>,
        children: [
            {
                path: '/dashboard/StudentsDashboard',
                element: <StudentDashGreen></StudentDashGreen>
            },
            {
                path: '/dashboard/PendingDetails/:id',
                loader: ({ params }) => fetch(`https://tutor-tree-server-1.vercel.app/allTutors/${params.id}`),
                element: <PendingDetails></PendingDetails>
            },
            {
                path: '/dashboard/jobsStudentDetails/:id',
                loader: ({ params }) => fetch(`https://tutor-tree-server-1.vercel.app/allTutors/${params.id}`),
                element: <StudentJobCardDetails></StudentJobCardDetails>
            },
            {
                path: '/dashboard/ReqTutor',
                element: <ReqTutor></ReqTutor>
            },
            {
                path: '/dashboard/term&Conditions',
                element: <TermConditions></TermConditions>
            },
            {
                path: '/dashboard/studentsSettings',
                element: <StudentSettingsTwo></StudentSettingsTwo>
            },
           


        ]
    },
    // teacher 
    {
        path: '/dashboardTwo',
        element: <PrivateRouteTwo><DashboardTwo></DashboardTwo></PrivateRouteTwo>,
        children: [
            // {
            //     path: '/dashboardTwo/allUsers',
            //     element: <AllTutors></AllTutors>
            // },
            {
                path: '/dashboardTwo/allUsers',
                element: <AdminTutors></AdminTutors>
            },
            // {
            //     path: '/dashboardTwo/allTutors',
            //     element: <AllTutorsTwo></AllTutorsTwo>
            // },
            {
                path: '/dashboardTwo/jobsMain',
                element: <JobBoardInnerGreen/>
            },
            // {
            //     path: '/dashboardTwo/jobsMain',
            //     element: <AllTutorsFour/>
            // },
            {
                path: '/dashboardTwo/TermsConditions',
                element: <TermsCondtionsTutor></TermsCondtionsTutor>
            },
            {
                path: '/dashboardTwo/jobsDetails/:id',
                loader: ({ params }) => fetch(`https://tutor-tree-server-1.vercel.app/allTutors/${params.id}`),
                element: <JobBoardInnerDetails></JobBoardInnerDetails>
            },
            {
                path: '/dashboardTwo/DashBoardDetails/:id',
                loader: ({ params }) => fetch(`https://tutor-tree-server-1.vercel.app/allTutorsReqq/${params.id}`),
                element: <TutorDashboardDetails></TutorDashboardDetails>
            },
            {
                path: '/dashboardTwo/tutorDashboard',
                element: <TutorDashBoardGreen></TutorDashBoardGreen>
            },
            {
                path: '/dashboardTwo/tutorProfile',
                element: <TutorProfileGreen></TutorProfileGreen>
                // element: <TutorProfile></TutorProfile>
            },
            {
                path: '/dashboardTwo/tutorPayment',
                element: <TutorPayment></TutorPayment>
            },
            // {
            //     path: '/dashboardTwo/tutorSubPayment',
            //     element: <TutorSubPayment></TutorSubPayment>
            // },
            {
                path: '/dashboardTwo/tutorSubPayment',
                element: <TutorPaymentGreenAll></TutorPaymentGreenAll>
            },
            {
                path: '/dashboardTwo/tutorSubReqRefund',
                element: <RequestRefound></RequestRefound>
            },
            {
                path: '/dashboardTwo/TutorSubPaymentDetailsBkash/:id',
                loader: ({ params }) => fetch(`https://tutor-tree-server-1.vercel.app/SentInvoiceMainDataUsingId/${params.id}`),
                element: <TutorSubPaymentDetailsBkash></TutorSubPaymentDetailsBkash>
            },
            {
                path: '/dashboardTwo/TutorSubPaymentDetails/:id',
                loader: ({ params }) => fetch(`https://tutor-tree-server-1.vercel.app/invoiceMainData/${params.id}`),
                element: <TutorJobDetails></TutorJobDetails>
            },
            {
                path: '/dashboardTwo/RefoundDetails/:id',
                loader: ({ params }) => fetch(`https://tutor-tree-server-1.vercel.app/invoiceMainData/${params.id}`),
                element: <RequestRefoundDetails></RequestRefoundDetails>
            },
            {
                path: '/dashboardTwo/personalProfile',
                element: <PersonalProfile></PersonalProfile>
            },
            {
                path: '/dashboardTwo/educationalProfile',
                element: <EducationalProfile></EducationalProfile>
            },
            {
                path: '/dashboardTwo/TutionProfile',
                element: <PreferProfileTwo></PreferProfileTwo>
            },
            {
                path: '/dashboardTwo/tutorSettings',
                element: <TutorSettings></TutorSettings>
            },
            {
                path: '/dashboardTwo/error?',
                element: <Error></Error>
            },
            {
                path: '/dashboardTwo/success',
                element: <Success></Success>
            },

            //  admin start
            {
                path: '/dashboardTwo/AdminDash',
                element: <AdminDashGreenMain></AdminDashGreenMain>
            },
            {
                path: '/dashboardTwo/AdminLeads',
                element: <LeadsGreen></LeadsGreen>
            },
            // {
            //     path: '/dashboardTwo/AdminLeads',
            //     element: <AdminLeadsTwo></AdminLeadsTwo>
            // },
            {
                path: '/dashboardTwo/AdminLeadsDetails/:id',
                loader: ({ params }) => fetch(`https://tutor-tree-server-1.vercel.app/allTutors/${params.id}`),
                element: <AdminLeadsDetails></AdminLeadsDetails>
            },
            {
                path: '/dashboardTwo/AdminAllApplication',
                element: <AllApplicationsGreen></AllApplicationsGreen>
            },
            {
                path: '/dashboardTwo/AdminAllApplicationDetails/:id',
                loader: ({ params }) => fetch(`https://tutor-tree-server-1.vercel.app/allTutors/${params.id}`),
                // element: <AllApplicationDetails></AllApplicationDetails>
                element: <AllApplicationGreenDetails></AllApplicationGreenDetails>
            },
            {
                path: '/dashboardTwo/AdminSortListed',
                element: <AdminShortListedGreen></AdminShortListedGreen>
            },
            {
                path: '/dashboardTwo/AdminSortListedDetails/:id',
                loader: ({ params }) => fetch(`https://tutor-tree-server-1.vercel.app/shortlistedData/${params.id}`),
                element: <AdminShortListedGreenDetails></AdminShortListedGreenDetails>
            },
            {
                path: '/dashboardTwo/AdminPendingConfirmation',
                element: <PendingConfirmation></PendingConfirmation>
            },
            {
                path: '/dashboardTwo/AdminPendingConfirmation/:id',
                loader: ({ params }) => fetch(`https://tutor-tree-server-1.vercel.app/pendingConfirmations/${params.id}`),
                element: <PendingConfirmationDetails></PendingConfirmationDetails>
            },
            {
                path: '/dashboardTwo/AdminPendingVerification',
                element: <PendingVerification></PendingVerification>
            },
            {
                path: '/dashboardTwo/AdminPendingVerification/:id',
                loader: ({ params }) => fetch(`https://tutor-tree-server-1.vercel.app/pendingVerification/${params.id}`),
                element: <PendingVerificationDetails></PendingVerificationDetails>
            },
            {
                path: '/dashboardTwo/AdminFollowUpTutor',
                element: <FollowUpTutor></FollowUpTutor>
            },
            {
                path: '/dashboardTwo/AdminFollowUpTutor/:id',
                loader: ({ params }) => fetch(`https://tutor-tree-server-1.vercel.app/followUpTutor/${params.id}`),
                element: <FollowUpTutorDetails></FollowUpTutorDetails>
            },
         
            {
                path: '/dashboardTwo/AdminFollowUpGuardian',
                element: <FollowUpGuardian></FollowUpGuardian>
            },
            {
                path: '/dashboardTwo/AdminFollowUpGuardian/:id',
                loader: ({ params }) => fetch(`https://tutor-tree-server-1.vercel.app/followUpGuardian/${params.id}`),
                element: <FollowUpGuardianDetails></FollowUpGuardianDetails>
            },
            {
                path: '/dashboardTwo/AdminClassBooked',
                element: <ClassBookedGreen></ClassBookedGreen>
            },
            {
                path: '/dashboardTwo/AdminClassBooked/:id',
                loader: ({ params }) => fetch(`https://tutor-tree-server-1.vercel.app/ClassBooked/${params.id}`),
                element: <ClassBookedGreenDetails></ClassBookedGreenDetails>
            },
            // {
            //     path: '/dashboardTwo/AdminAllInvoice',
            //     element: <AllInvoiceGreen></AllInvoiceGreen>
            // },
            {
                path: '/dashboardTwo/AdminAllInvoice',
                element: <MainInvoicePage></MainInvoicePage>
            },
            {
                path: '/dashboardTwo/AllInvoiceDetails/:id',
                loader: ({ params }) => fetch(`https://tutor-tree-server-1.vercel.app/ClassBookedMainData/${params.id}`),
                element: <AllInvoiceDetails></AllInvoiceDetails>
            },
            {
                path: '/dashboardTwo/AllInvoiceJobDetails/:id',
                loader: ({ params }) => fetch(`https://tutor-tree-server-1.vercel.app/invoiceMainData/${params.id}`),
                element: <InvoiceJobDetails></InvoiceJobDetails>
            },
            {
                path: '/dashboardTwo/AllJobAdmin',
                element: <AllJobAdmin></AllJobAdmin>
            },
            {
                path: '/dashboardTwo/AdminUserDatabase',
                element: <UserDatabase></UserDatabase>
            },
            {
                path: '/dashboardTwo/AdminTutorDatabaseDetails/:id',
                loader: ({ params }) => fetch(`https://tutor-tree-server-1.vercel.app/allUsers/${params.id}`),
                element: <TutorDatabaseDetails></TutorDatabaseDetails>
            },
            {
                path: '/dashboardTwo/AdminGuardianDatabaseDetails/:id',
                loader: ({ params }) => fetch(`https://tutor-tree-server-1.vercel.app/userTwoID/${params.id}`),
                element: <GuardianDatabaseDetails></GuardianDatabaseDetails>
            },
            {
                path: '/dashboardTwo/AdminRefunds',
                element: <Refunds></Refunds>
            },
            {
                path: '/dashboardTwo/RequestRefundDetails/:id',
                loader: ({ params }) => fetch(`https://tutor-tree-server-1.vercel.app/refundsMainData/${params.id}`),
                element: <RequestRefundsDetails></RequestRefundsDetails>
            },
            {
                path: '/dashboardTwo/AdminSMS',
                element: <SMSGreen></SMSGreen>
            },
            // {
            //     path: '/dashboardTwo/AdminSMS',
            //     element: <SMS></SMS>
            // },
            {
                path: '/dashboardTwo/AdminPerformance',
                element: <Performance></Performance>
            },
            {
                path: '/dashboardTwo/AdminAddLeads',
                element: <AdminAddLeads></AdminAddLeads>
            },
           
         

            // admin end
            // super admin start
            {
                path: '/dashboardTwo/SuperAdminDashboard',
                element: <SuperAdminDashboard></SuperAdminDashboard>
            },
            {
                path: '/dashboardTwo/SuperAdminLeads',
                element: <SuperAdminLeads></SuperAdminLeads>
            },
            {
                path: '/dashboardTwo/SuperAdminAddLeads',
                element: <SuperAdminAddLeads></SuperAdminAddLeads>
            },
            {
                path: '/dashboardTwo/SuperAllApplicants',
                element: <SuperAdminAllApplicationsTwo></SuperAdminAllApplicationsTwo>
            },
            {
                path: '/dashboardTwo/SuperAdminShortlisted',
                element: <SuperAdminShortlistedTwo></SuperAdminShortlistedTwo>
            },
            {
                path: '/dashboardTwo/SuperPendingConfirmation',
                element: <SuperAdminPendingConfirmation></SuperAdminPendingConfirmation>
            },
            {
                path: '/dashboardTwo/SuperPendingVerification',
                element: <SuperAdminPendingVerification></SuperAdminPendingVerification>
            },
            {
                path: '/dashboardTwo/SuperFollowUpTutor',
                element: <SuperAdminFollowUpTutor></SuperAdminFollowUpTutor>
            },
            {
                path: '/dashboardTwo/SuperFollowUpGuardian',
                element: <SuperAdminFollowUpGuardian></SuperAdminFollowUpGuardian>
            },
            {
                path: '/dashboardTwo/SuperClassBooked',
                element: <SuperAdminClassBooked></SuperAdminClassBooked>
            },

            {
                path: '/dashboardTwo/SuperInvoice',
                element: <SuperInvoice></SuperInvoice>
            },
            {
                path: '/dashboardTwo/SuperAdminPerformance',
                element: <SuperAdminPerformance></SuperAdminPerformance>
            },
            {
                path: '/dashboardTwo/SuperInvoiceDetails/:id',
                loader: ({ params }) => fetch(`https://tutor-tree-server-1.vercel.app/ClassBookedMainData/${params.id}`),
                element: <SuperInvoiceDetails></SuperInvoiceDetails>
            },
            {
                path: '/dashboardTwo/SuperRefunds',
                element: <SuperRefunds></SuperRefunds>
            },
            {
                path: '/dashboardTwo/SuperRefundsRequestDetails/:id',
                loader: ({ params }) => fetch(`https://tutor-tree-server-1.vercel.app/refundsMainData/${params.id}`),
                element: <SARefundRequestDetails></SARefundRequestDetails>
            },
            {
                path: '/dashboardTwo/SuperRefundsDoneDetails/:id',
                loader: ({ params }) => fetch(`https://tutor-tree-server-1.vercel.app/refundsMainData/${params.id}`),
                element: <SARefundedDoneDetails></SARefundedDoneDetails>
            },
            {
                path: '/dashboardTwo/SuperRefundsDenyDetails/:id',
                loader: ({ params }) => fetch(`https://tutor-tree-server-1.vercel.app/refundsMainData/${params.id}`),
                element: <SARefundRequestDeniedDetails></SARefundRequestDeniedDetails>
            },

        ]
    },
    //  teacher mobile
    {
        path: '/dashboardTutorMobile',
        element: <PrivateRouteTutorMobile><DashboardTutorMobile/></PrivateRouteTutorMobile>,
        children: [
         
            {
                path: '/dashboardTutorMobile/dash-tutor-mobile',
                element: <PrivateRouteTutorMobile><DashTutorMobile></DashTutorMobile></PrivateRouteTutorMobile>
            },
            {
                path: '/dashboardTutorMobile/tutor-profile-mobile',
                element: <PrivateRouteTutorMobile><TutorProfileMobile></TutorProfileMobile></PrivateRouteTutorMobile>
            },
            {
                path: '/dashboardTutorMobile/tutor-profile-job-board-mobile',
                element: <PrivateRouteTutorMobile><TutorJobBoardInnerMobile></TutorJobBoardInnerMobile></PrivateRouteTutorMobile>
            },
            {
                path: '/dashboardTutorMobile/tutor-settings-mobile',
                element: <PrivateRouteTutorMobile><TutorSettingMobile></TutorSettingMobile></PrivateRouteTutorMobile>
            },
            {
                path: '/dashboardTutorMobile/tutor-payment-mobile',
                element: <PrivateRouteTutorMobile><TutorPaymentMobile></TutorPaymentMobile></PrivateRouteTutorMobile>
            },
       

        ]
    },
])

export default router;